import PocketBase from "pocketbase";
export const pocketbase = new PocketBase("https://wallpaper-api.noapi.space");
pocketbase.autoCancellation(false);
